<template>
  <div
    class="gallery-slot-all-popup h-full w-full flex flex-col items-center justify-evenly text-texts-standard-default text-36"
  >
    {{ $t('gallery.slotConfirmMessage') }}

    <div class="puzzle-pieces-count-wrapper">
      <div class="w-full h-full flexing gap-14 text-texts-standard-important font-bold text-32">
        <div
          v-for="pieceData in pieces"
          :key="pieceData.rarity"
          class="flexing flex-col"
        >
          <app-main-icon class="puzzle-icon" :icon-name="`puzzle-${pieceData.rarity}`" :icon-size="80" />
          <div class="puzzle-pieces-count flexing">{{ pieceData.count }}</div>
        </div>
      </div>
    </div>

    <app-button btn-type="confirm" :btn-text="$t('gallery.confirm')" @click="placeAllPieces" />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import AppButton from '../GlobalComponents/AppButton.vue'
import AppMainIcon from '../GlobalComponents/AppMainIcon.vue'
import { mapState, mapActions } from 'pinia'
import { useGalleryPictureStore } from '@/store/pinia/gallery/pictureStore'
import type { PieceCountByRarity } from '@/interfaces/gallery/Pictures'

export default defineComponent({
  name: 'GallerySlotAllPopup',
  components: { AppButton, AppMainIcon },

  props: {
    pieces: {
      type: Array as PropType<PieceCountByRarity[]>,
      default: () => []
    }
  },

  emits: ['close'],

  computed: {
    ...mapState(useGalleryPictureStore, ['picture'])
  },

  methods: {
    ...mapActions(useGalleryPictureStore, ['assemble']),

    placeAllPieces() {
      this.assemble('all')
      this.$emit('close')
    },
  },
})
</script>

<style lang="scss" scoped>
.gallery-slot-all-popup {
  height: 24.6875rem;

  .puzzle-pieces-count-wrapper {
    width: 100%;
    height: 9.375rem;
    @if $isWsm {
      background-image: linear-gradient(
        90deg,
        rgba(108, 158, 196, 0) 0%,
        rgba(108, 158, 196, 0.8) 15%,
        rgba(108, 158, 196, 0.8) 85%,
        rgba(108, 158, 196, 0) 100%
      );
    }
    @if $isSsm {
      background-image: linear-gradient(
        90deg,
        rgba(86, 98, 127, 0) 0%,
        rgba(86, 98, 127, 0.8) 15%,
        rgba(86, 98, 127, 0.8) 85%,
        rgba(86, 98, 127, 0) 100%
      );
    }
  }
}
</style>
